export default "__VITE_ASSET__CC8s5$3p__"